import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {ItemValueOverride} from '@emm/common-items/components/value-overrides-card/value-overrides-card.component';
import {openCommonItemInReact} from '@emm/core/util/common-item-url.util';

export interface AttributeOverrideDialogData {
    attributeName: string;
    attributeJsonProperty: string;
    overrides: ItemValueOverride[];
    baseValue: unknown;
    formValue: unknown;
    itemTag: string;
    itemClass: string;
}

interface GroupedVariationOverride {
    variationTag: string;
    variationLabel: string;
    overrides: ItemValueOverride[];
}

@Component({
    selector: 'emm-attribute-override-detail-dialog',
    templateUrl: './attribute-override-detail-dialog.component.html',
    styleUrls: ['./attribute-override-detail-dialog.component.scss'],
    standalone: false
})
export class AttributeOverrideDetailDialogComponent {
    attributeName: string;
    baseValue: unknown;
    formValue: unknown;
    groupedOverrides: GroupedVariationOverride[] = [];
    private itemTag: string;

    constructor(
        public dialogRef: MatDialogRef<AttributeOverrideDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AttributeOverrideDialogData,
    ) {
        this.attributeName = data.attributeName;
        this.baseValue = data.baseValue;
        this.formValue = data.formValue;
        this.itemTag = data.itemTag;
        this.groupedOverrides = this.groupByVariation(data.overrides);
    }

    private groupByVariation(overrides: ItemValueOverride[]): GroupedVariationOverride[] {
        const map = new Map<string, ItemValueOverride[]>();
        for (const o of overrides) {
            if (o.base) {
                continue;
            }
            const key = o.variationTag || 'Unknown';
            if (!map.has(key)) {
                map.set(key, []);
            }
            map.get(key)!.push(o);
        }

        const variationGroups: GroupedVariationOverride[] = Array.from(map.entries()).map(([variation, items]) => ({
            variationTag: variation,
            variationLabel: items[0]?.variationLabel || variation,
            overrides: items,
        }));

        const baseGroup: GroupedVariationOverride = {
            variationTag: this.itemTag,
            variationLabel: 'Base Item',
            overrides: [],
        };

        return [baseGroup, ...variationGroups];
    }

    doesGroupMatchFormValue(group: GroupedVariationOverride): boolean {
        for (const o of group.overrides) {
            if (this.normalize(o.value) === this.normalize(this.formValue)) {
                return true;
            }
        }
        return false;
    }

    private normalize(val: unknown): string {
        if (val === null || val === undefined) {
            return '';
        }
        return String(val).trim();
    }

    navigateToVariation(variationTag: string): void {
        openCommonItemInReact(this.itemTag, {variation: variationTag});
    }

    close(): void {
        this.dialogRef.close();
    }
}
